import { render, staticRenderFns } from "./GenericData.vue?vue&type=template&id=4d214237&scoped=true&"
import script from "./GenericData.vue?vue&type=script&lang=js&"
export * from "./GenericData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d214237",
  null
  
)

export default component.exports